/* TASK 3 — fee-sync: κρατά τις γραμμές «Χρέωση χαράγματος» ΠΑΝΤΑ ίσες με ό,τι
   υπολογίζει server-side το engraving-fee-data.liquid (ΤΟ ΕΝΑ ΣΗΜΕΙΟ config).
   Ροή: κάθε cart mutation → drawer re-render (Section Rendering) → φρέσκο
   [data-eng-desired] JSON → diff με τις υπάρχουσες fee-γραμμές → /cart/update.js.
   Fail-open: αν το fee-προϊόν λείπει/σφάλμα → καμία χρέωση, το Trello-δίχτυ πιάνει
   το κείμενο-χωρίς-χρέωση (ομάδα βλέπει κάθε χαραγμένη παραγγελία πριν χαραχτεί). */
(function () {
  'use strict';
  var variantMap = null; /* τιμή€ (ακέραιο) → variant id */
  var syncing = false;
  var disabled = false;

  function readDesired() {
    var el = document.querySelector('[data-eng-desired]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function loadVariants(handle) {
    if (variantMap) return Promise.resolve(variantMap);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('no fee product'); return r.json(); })
      .then(function (p) {
        variantMap = {};
        (p.variants || []).forEach(function (v) { variantMap[Math.round(v.price / 100)] = v.id; });
        return variantMap;
      });
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var dialog = document.querySelector('[data-cart-drawer]');
        if (dialog && data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          dialog.firstElementChild.innerHTML = tmp.firstElementChild.innerHTML;
        }
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        });
      });
  }

  function sync() {
    if (syncing || disabled) return;
    var desired = readDesired();
    if (!desired) return;
    syncing = true;
    Promise.all([loadVariants(desired.feeHandle), fetch('/cart.js').then(function (r) { return r.json(); })])
      .then(function (res) {
        var map = res[0];
        var cart = res[1];
        var want = {};
        /* Σ07-13: fees = [{k: item.key, f: ποσό}] (το k το χρησιμοποιεί ο ακαριαίος
           δρόμος του cart.js — εδώ μετράμε μόνο τα ποσά) */
        (desired.fees || []).forEach(function (o) { want[o.f] = (want[o.f] || 0) + 1; });
        var current = {};
        (cart.items || []).forEach(function (it) {
          if (it.handle === desired.feeHandle) current[it.variant_id] = it.quantity;
        });
        var updates = {};
        var changed = false;
        Object.keys(map).forEach(function (val) {
          var vid = map[val];
          var wq = want[val] || 0;
          var cq = current[vid] || 0;
          if (wq !== cq) { updates[vid] = wq; changed = true; }
        });
        if (!changed) { syncing = false; return; }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function (r) {
          if (!r.ok) throw new Error('update failed');
          return refreshDrawer();
        }).then(function () {
          syncing = false;
          /* το refresh φέρνει νέο desired-JSON· ξανά sync = no-op όταν συγκλίνει */
          sync();
        });
      })
      .catch(function () { disabled = true; syncing = false; });
  }

  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('cart:updated', sync);

  /* fast-ATC hook (cart.js): δίνει το variant id της χρέωσης ώστε να προστεθεί
     στο ΙΔΙΟ βήμα με το προϊόν — το sync μετά απλώς επιβεβαιώνει (no-op) */
  window.__engFeeVariantId = function (fee) {
    return loadVariants('xrewsi-xaragmatos').then(function (map) { return map[fee] || null; });
  };
})();
